import React, { Component, Fragment } from "react"
import Responsive from "react-responsive"
import { observer } from "mobx-react"
import { Button, Container, Dropdown, Icon, Image, Menu, MenuItem, Modal, Table } from "semantic-ui-react"
import { Link, NavLink } from "react-router-dom"
import CartButton from "components/Cart/CartButton"
import CartMini from "components/Cart/CartMini"
import shop from "shop/shop"
import MenuBySlug from "components/Menu/MenuBySlug"
import { Col, Row } from "elemental-react16"
import languageStore from "stores/languageStore"
import app from "app.controller"
import "style/header.scss"
import searchStore from "stores/searchStore"
// import { SearchForm }              from "components/Search/SearchBarWithOptions"
import { SearchForm } from "components/Search/SearchBarWithTypeahead"
import categoryStore from "stores/categoryStore"
import { useLocation, withRouter } from "react-router"
import Typeahead from "../../../../components/Typeahead/Typeahead";
import BaseLayout from "layout/BaseLayout"

// import Navigation from "../Navigation/Navigation"
@observer
export default class Header extends Component {

  constructor() {
    super()
    this.state = {
      list: shop.orderlist.default,
      categoryData: false,
      toggleSideBar: false
    }
  }

  componentDidMount() {
    shop.events.loaded.add(this.handleLoad)
    shop.orderlist.default.events.change.add(this.handleOrderlist)
  }

  handleOrderlist = ({ list }) => {
    this.setState({
      list
    })
  }

  handleLoad = () => {
    this.setState({
      categoryData: shop.categories
    })
  }

  componentWillUnmount() {
    shop.orderlist.default.events.change.remove(this.handleOrderlist)
    shop.events.loaded.remove(this.handleLoad)
  }

  render() {
    const { showMini } = this.state
    return (
      <header className={`header ${showMini}`}>
        <Responsive maxWidth={864}>
          <div>
            {showMini && <MiniHeaderMobile />}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState({ showMini: false })
              }}
              onPassed={() => {
                console.log("scrolled")
                this.setState({ showMini: "scrolled" })
              }}>
              <MobileHeader />
            </OnOffset>
          </div>
        </Responsive>
        <Responsive minWidth={865}>
          <div>
            {showMini && <MiniHeader />}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState({ showMini: false })
              }}
              onPassed={() => {
                console.log("scrolled")
                this.setState({ showMini: "scrolled" })
              }}>
              <DesktopHeader />
            </OnOffset>
          </div>
        </Responsive>
      </header>
    )
  }
}

class MobileHeader extends Component {
  render() {
    const { inverted = false } = this.props
    return (
      <div className="MobileHeader">
        <div className="pa2 ph2 ph4-ns pa3-ns">
          <div className="flex flex-row justify-between items-center">
            <div className={"w-100 flex flex-row justify-start"}>
              <Button basic inverted={inverted} icon="bars" onClick={app.sidebarLeft.toggle.dispatch} />
              <SettingsModal inverted={inverted} />
            </div>

            <div className={"w-100 flex flex-row items-center justify-center"}>
              <NavLink to="/home/" className={"Logo"}>
                <img src={shop.config.logo} style={{ width: "115px" }} alt="zur Startseite" />
              </NavLink>
            </div>

            <div className={"w-100 flex flex-row justify-end items-center"}>
              {/*<Search />*/}
              <Button basic inverted={inverted} icon="search" as={Link} to={"/search/"} />
              <CartButton inverted={inverted} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const SettingsModal = ({ inverted }) => {
  return (
    <Modal trigger={<Button basic inverted={inverted} icon="settings" />}>
      <Modal.Content>
        <SettingsMenu vertical />
      </Modal.Content>
    </Modal>
  )
}


const SettingsMenu = observer(
  (props) => {
    const { currentLanguage } = languageStore
    return (
      <Menu secondary
        borderless
        fluid
        {...props}
        size="small">

        {/* LEFT SIDE MENU */}
        {shop.session && <Menu.Item
          position="right"
          as={Link}
          to="/orderlist/"><Icon name={"heart"} /> {translate("Orderlist")}</Menu.Item>}

        {/* RIGHT SIDE MENU*/}

        {(shop.session && shop.session.handId) && <Menu.Item as={Link} to="/login/accounts/">{translate("Clients")}</Menu.Item>}
        {shop.session && <Menu.Item as={Link} to="/quickorder/"><Icon name={"shopping basket"} />{translate("Quickorder")}</Menu.Item>}
        {shop.session && <Menu.Item as={Link} to="/account/"><Icon name={"user"} />{translate("My Account")}</Menu.Item>}
        {shop.session && <Menu.Item as={Link} to="/logout/"><Icon name={"power off"} />{translate("Logout")}</Menu.Item>}
        {!shop.session && <LoginLink />}
        {languageStore.available.length > 1 && <Dropdown text={currentLanguage.toUpperCase()}
          pointing
          className="link item">
          <Dropdown.Menu>
            {languageStore.available.map(locale => <Dropdown.Item
              key={locale}
              onClick={() => languageStore.setLanguage(locale)}>{locale}</Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>}
      </Menu>
    )
  }
)

function LoginLink() {
  const location = useLocation()
  return <Menu.Item
    position="right"
    as={Link}
    to={`/login?referrer=${location.pathname + location.search}`}><Icon name={"power on"} />{translate("Anmelden")}</Menu.Item>
}

function LoginLink2() {
  const location = useLocation()
  return <Button as={Link} to={`/login/?referrer=${location.pathname}`} primary>{translate("Anmelden")}</Button>
}

@observer
class DesktopHeader extends Component {
  state = {
    toggleSidebar: false
  }

  toggleSideBarCart = () => {
    app.sidebar.toggle.dispatch
  }

  render() {
    return (
      <div >
        <div style={{ backgroundColor: "#white", color: "black", border: "1px" }} className="bb b--black-90 bw1 top-menu-mini absolute primary top-0 left-0 right-0 z-3" >

          <div className="flex flex-row justify-between items-center" >
            {/*<a className={"f5 ph3 pv2 primary"} href={"//mags-vertrieb.de/"}>
              <div className="nowrap primary"><Icon icon="chevron left"/> {translate( "zurück zu mags-vertrieb.de" )}</div>
    </a>*/}
            <SettingsMenu attached />
          </div>
        </div>
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState({ showMini: false })
          }}
          onPassed={() => {
            this.setState({ showMini: "scrolled" })
          }}>
          <Row className="pt5 pb2">
            <Col sm="5/16"></Col>
            <Col sm="2/16">

              <div className="flex flex-row items-center justify-center">
                <div className="pr7">                      <SearchForm
                  style={{ width: "170px" }}
                  className={"mw6 w-100"}
                  value={searchStore.searchTerm}
                  onChange={e => {
                    searchStore.setSearchTerm(e.target.value)
                  }} icon="search" placeholder={translate("Suche") + "..."} /></div>
              </div>
            </Col>
            <Col sm="5/16" className="tc"><div className="tc">
              <NavLink to="/home/" className={"Logo"}>
                <img
                  src={shop.config.logo}
                  alt="zur Startseite" />
              </NavLink></div>
            </Col>
            <Col sm="4/16">
              {shop.session && <CartButton />}
              {!shop.session && <Fragment><LoginLink2 />&nbsp;&nbsp;
                <Button as={Link} to={"/customer_registration/"} className="buttonFade" >{translate("Registrieren")}</Button></Fragment>}
            </Col>
          </Row>
          {/*<div className="top-menu bg-white pt3 pl3 pr3 pb3" style={{zIndex: 100}}>
            <Container className="relative">

              <div className="flex flex-row items-center justify-center">
              <div className="pr7">                      <SearchForm
                        style={{ width: "170px" }}
                        className={"mw6 w-100"}
                        value={searchStore.searchTerm}
                        onChange={e => {
                          searchStore.setSearchTerm( e.target.value )
                        }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
                
                <NavLink to="/home/" className={"Logo"}>
                  <img
                    src={shop.config.logo}
                    alt="zur Startseite"/>
                </NavLink>
                {!shop.session &&<div className="pl7"><Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary>{translate( "Anmelden" )}</Button>&nbsp;&nbsp;
                  <Button as={Link} to={"/customer_registration/"}  className="buttonFade" >{translate( "Registrieren" )}</Button></div>}
                  {shop.session && <div className="pl7"><CartButton/></div>}
                  {shop.session && <div className="pl6"></div>}
                  {shop.session && <div className="pl4"></div>}
              </div>
              
              
              <div className="absolutetop-0 mt1">

              </div>
              
              <div className="tc pb3">
                <div className="logo--shop block">
                </div>
              </div>
            </Container>
          </div>*/}
        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        <MinimalMenuHeader />
      </div>
    )
  }
}

const MiniHeaderMobile = () => <div
  className="mini-header z-6 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
  <div className="ph2">
    <Menu borderless
      secondary>
      <Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon name="bars" /></Menu.Item>
      <Menu.Item>
        <Modal trigger={<Icon name="settings" />}>
          <Modal.Content>
            <SettingsMenu vertical />
          </Modal.Content>
        </Modal>
      </Menu.Item>
      <Menu.Item as={Link} to="/orderlist/" position="right"><Icon name="like" /></Menu.Item>
      <Menu.Item as={Link} to="/search/"><Icon name="search" /></Menu.Item>
      {shop.session && <Menu.Item><CartButton /></Menu.Item>}
    </Menu>
  </div>
</div>


const MiniHeader = () => <div className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
  <div className="ph2">
    <MenuBySlug slug={"header"} key={"mini-header-main"} secondary borderless>
      <Menu.Item position="right" content={translate("Orderlist")} as={Link} to="/orderlist/" />
      <Menu.Item as={Link} to="/search/"><Icon name="search" /></Menu.Item>
      {shop.session && <Menu.Item><CartButton /></Menu.Item>}
    </MenuBySlug>
  </div>
</div>


class OnOffset extends Component {

  state = {
    passed: false
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    let { passed } = this.state
    let { pageYOffset } = window
    if (pageYOffset > this.props.offset) {
      if (!passed) {
        this.setState({ passed: true })
        this.props.onPassed && this.props.onPassed()
      }
    } else {
      if (passed) {
        this.setState({ passed: false })
        this.props.onPassedReverse && this.props.onPassedReverse()
      }
    }
  }

  render() {
    return this.props.children || null
  }
}


@observer
class MegaMenu extends Component {

  state = {
    hover: false,
    index: false
  }

  onLeave = () => {
    this.setState({ hover: false })
    window.setTimeout(() => {
      let { hover } = this.state
      if (!hover) this.setState({ index: false })
    }, 200)
  }

  onHover = ({ index }) => {
    this.setState({ index, hover: true })
  }

  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const category = shop.categoriesById.get(index)

    return <div className="MegaMenu bg-blue relative" style={{ zIndex: 99 }}>
      <Container className="">
        <div className="pb2">
          {categories.length > 0 && <div>
            <Menu inverted attached="bottom" fluid stackable secondary widths={categories.length}>
              {categories.map(category => {

                if (category.children.length === 0) {
                  return <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}>{category.title}</Menu.Item>
                }

                return <Dropdown key={category.map_id} item text={category.title}>
                  <Dropdown.Menu>
                    <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}><b>{category.title}</b></Menu.Item>
                    {category.children.map(category => {
                      return <Dropdown.Item as={Link} to={`/collection/${category.map_id}/`}
                        key={category.map_id}>{category.title}</Dropdown.Item>
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              }
              )}
            </Menu>

          </div>
          }


        </div>

      </Container>
    </div>
  }
}


let isHovering = false

@observer
@withRouter
export class MinimalMenuHeader extends Component {

  state = {
    hover: false,
    index: false
  }

  onLeave = () => {
    isHovering = false
    this.setState({ hover: false })
    window.setTimeout(() => {
      let { hover } = this.state
      if (!hover) this.setState({ index: false })
    }, 120)
  }

  onHover = ({ index }) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout(() => {
      if (isHovering) this.setState({ index, hover: true })
    }, DELAY)
  }

  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const selectedCategory = shop.categoriesById.get(index)
    let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
    return (
      <div style={{ backgroundColor: "#ffffff", color: "black" }} className="bb b--black-20 ">
        <Container className="">
          <div className="flex flex-row justify-center items-center flex-wrap space-around">
            <div>
              <Link className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" style={{ color: "black" }} to={`/home`}>{translate("Startseite")}</Link>
            </div>
            <div>
              <Link className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" to={`/collection/AlleProdukte/`}>{translate("Alle Produkte")}</Link>
            </div>
            <div>
              <Link className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" style={{ color: "black" }} to={`/collection/Topseller/`}>Topseller</Link>
            </div>
            {/*shop.session && <div>
              <Link className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" style={{ color: "black" }} to={`/account/`}>{translate("Ihre Topseller")}</Link>
            </div>*/}
            {shop.session && <div>
              <a className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" style={{ color: "black" }} href="/account/">{translate("Ihre Topseller")}</a>
            </div>}
            <div className="ui simple dropdown link item pa1 f4 fw5 pr3 pl3 ">
              <span className="text " style={{ color: "black" }}>{translate("Marken")}</span>
              <i className="black dropdown icon"></i>
              <div className="menu" style={{ zIndex: 9999 }}>
                {/*<div className="header" >Kategorien</div>*/}
                {categories
                  .map(category => {
                    //console.log('CAT: ' + JSON.stringify(category));
                    if (category.isHidden || category.map_id == 'neuheit' || category.map_id == 'sale' || category.map_id == 'Topseller') return null
                    return <div className="item" key={category.map_id}><Link style={{ color: "black", display: "block" }} to={`/collection/${category.map_id}/`}>{category.title}</Link></div>
                  })}
              </div>
            </div>
            <div>
              <Link className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" style={{ color: "black" }} to={`/cms/themenwelten`}>{translate("Kategorien")}</Link>
            </div>
            {shop.session && <div>
              <Link className="item pa1 pr3 pl3 f4 fw5 hoverAContainer" style={{ color: "#892e2e" }} to={`/collection/sale`}>Sale %</Link>
            </div>}
          </div>
        </Container>
      </div>
    )
  }
}

@observer
@withRouter
export class MegaMenuBig extends Component {

  state = {
    hover: false,
    index: false,
  }

  onLeave = () => {
    isHovering = false
    this.setState({ hover: false })
    window.setTimeout(() => {
      let { hover } = this.state
      if (!hover) this.setState({ index: false })
    }, 120)
  }

  onHover = ({ index }) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout(() => {
      if (isHovering) this.setState({ index, hover: true })
    }, DELAY)
  }

  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const selectedCategory = shop.categoriesById.get(index)
    let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
    const friendOptions = [
      {
        key: 'Kategorien',
        text: 'Kategorien',
        value: 'Kategorien',
        image: { avatar: true, src: `` },
      }
    ]
    categories.map(category => {
      if (category.isHidden) return null
      friendOptions.push({ key: category.map_id, text: category.title, value: category.map_id, image: { avatar: true, src: `` } })
    })

    return <div
      onMouseLeave={this.onLeave}

      className="TopMenuOrtho bg-dark relative" style={{ color: "#74747c;", zIndex: 99 }}>
      <Container className="">
        {/*<Dropdown inline className="pa3 f3" placeholder="TEST" > 
        <Dropdown.Menu defaultValue="TEST" >
          <Dropdown.Item text="Kategorien" key="Kategorien"/>
        {categories
                .map( category => {
                  if(category.isHidden) return null
                  //console.log("category", category )
                  //console.log("category.pic" + baseUrl + "/shop/rest/data/images/description/" + category.map_pic_id + "/1?size=small"  )
                  //image={`${baseUrl}/shop/rest/data/images/description/${category.map_pic_id}/1?size=small`}
                    return <Dropdown.Item text={category.title} key={category.map_id} as={Link} to={`/collection/${category.map_id}/`} />
                })}
        </Dropdown.Menu>
              </Dropdown>*/}
        <div className="TopMenuOrtho"></div>
        <div className="">
          {categories.length > 0 &&
            <div className={"flex flex-row f2 justify-start items-center flex-wrap space-around"}>
              {categories
                .map(category => {
                  if (category.isHidden) return null
                  // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                  const active = document.location.pathname.startsWith(`/collection/${category.map_id}/`) || selectedCategory && selectedCategory.map_id === category.map_id
                  return <Link key={category.map_id}
                    onClick={() => {
                      this.setState({ index: false, hover: false })
                    }}
                    className={` db pv3 pr1 pl1 f2 black nowrap fw5 hover-black space-around  ${active ? "active" : ""}`}
                    onMouseEnter={(e) => this.onHover({ index: category.map_id })}
                    to={`/collection/${category.map_id}/`}><span className="dib pr2 f5">{category.title}
                      {/*^className={` db pv3 pl6 pr4 f2 white nowrap hover-primary space-around  ${active ? "active" : ""}`}*/}
                      {/*<span className="red">({category.sort})</span>*/}
                    </span>
                  </Link>
                })
              } </div>

          }
          <div className="BotMenuOrtho"></div>
        </div>

        {/*selectedCategory && <Container
          style={{ padding: 0 }}
          onMouseLeave={this.onLeave}
          className=" absolute bg-dark left-0 right-0 z-999 animate fadeIn">
          <div>
            <div className="flex flex-row justify-between bg-black-10">
              <Link className={"db pa3 f6 ph4 white nowrap fw4 hover-primary b f6"} onClick={this.onLeave} to={`/collection/${selectedCategory.map_id}/`}>
                {selectedCategory.title} <Icon name={"chevron right"}/></Link>
              <Button className={"white pointer pa3 icon-button"} onClick={this.onLeave} icon={"times"}/>
            </div>
            <div className="pa4-ns pa3 pb4">
              <div className="flex flex-row flex-wrap ">
                {selectedCategory.children.map( subCategory => {
                  const active = document.location.pathname.startsWith( `/collection/${selectedCategory.map_id}/${subCategory.map_id}/` )
                  return <div className="pr4 pb4 " key={subCategory.map_id}>
                    
                    {/*LEVEL II }
                    <Link
                      onClick={() => {
                        this.setState( { index: false, hover: false } )
                      }}
                      className={`db f6 pv2 pb3 b white nowrap fw5 hover-primary ${active ? "active" : ""}`}
                      to={`/collection/${selectedCategory.map_id}/${subCategory.map_id}/`}
                    ><b>{subCategory.title}
                      {/*<span className="red">({subCategory.sort})</span>}
                    </b></Link>
                    {/*LEVEL III}
                    {subCategory.children.map( c => <Link
                      key={c.map_id}
                      onClick={() => {
                        this.setState( { index: false, hover: false } )
                      }}
                      className={`db f6 pv1 pb2 white-80 nowrap fw4 hover-primary ${active ? "active" : ""}`}
                      to={`/collection/${selectedCategory.map_id}/${c.map_id}/`}
                    >{c.title}
                      {/*<span className="red">({c.sort})</span>}
                    </Link> )}
                  </div>
                } )}
              </div>
            </div>
          </div>
              </Container>*/}
      </Container>
    </div>
  }
}





// WEBPACK FOOTER //
// ./src/theme/mags/components/Header/Header.js